import styled from "styled-components";
export const EmptyStateContainer = styled.div.withConfig({
  displayName: "merge-unit-empty-statestyles__EmptyStateContainer",
  componentId: "sc-by7ja5-0"
})(["flex-direction:", ";", " & >:first-child{", "}"], ({
  direction
}) => direction, {
  display: "flex",
  alignItems: "center",
  "--tw-text-opacity": "1",
  color: "rgba(156, 163, 175, var(--tw-text-opacity))"
}, {
  marginRight: "1rem"
});
